import React, { ReactNode } from 'react';

import Portal from '@mui/material/Portal';

import { Box } from '@vk-hr-tek/ui/Box';

interface PageRightAreaProps {
  children?: ReactNode;
}

export const PageRightArea = ({ children }: PageRightAreaProps) => {
  const rightAreaEl = document.getElementById('page-right-area');

  if (!children || !rightAreaEl) return null;

  return (
    <Portal container={rightAreaEl}>
      <Box
        width={360}
        height="100%"
        borderLeft={1}
        borderColor="stroke.primary"
        bgcolor="bg.light.primary"
      >
        {children}
      </Box>
    </Portal>
  );
};
